import { render } from "./ArticlePhotoText.vue?vue&type=template&id=7a6e2555&scoped=true"
import script from "./ArticlePhotoText.vue?vue&type=script&lang=js"
export * from "./ArticlePhotoText.vue?vue&type=script&lang=js"

import "./ArticlePhotoText.vue?vue&type=style&index=0&id=7a6e2555&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a6e2555"]])

export default __exports__